'use client'

import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';

import React, {ReactNode, useContext, useState} from 'react';

import {
    Container,
    Heading,
    Box,
    Flex,
    Icon,
    Avatar,
    Text,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    useDisclosure,
    Image,
    useColorModeValue,
    Stack,
    chakra,
} from '@chakra-ui/react';

import {MoonIcon, SunIcon, useBreakpointValue} from '@chakra-ui/icons';
import Cookies from 'js-cookie';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import required modules
import { Pagination,Keyboard, Mousewheel, Navigation } from 'swiper/modules';

import { FaTwitter, FaYoutube, FaInstagram } from 'react-icons/fa';

import '@react-pdf-viewer/core/lib/styles/index.css';

// import { AppStoreBadge } from '#/components/AppStoreBadge';
// import { PlayStoreBadge } from '#/components/PlayStoreBadge';

import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react';
import {useEvoContext} from "../../context/evo.context";
import PublicIssuesDataProvider from "../dataProviderEvo/public-issues-data-provider";
import {useLocation} from "react-router-dom";
import {Header} from "../header/Header";
import {Footer} from "../footer/Footer";
import {ReadIssueLink, ReadIssueWithImageLink} from "../links/ReadIssueWithImageLink";
import IssueDetailDataProvider from "../dataProviderEvo/issue-detail-data-provider";
import IssuePublicDataProvider from "../dataProviderEvo/issue-public-data-provider";
import {ROUTE_ISSUE_LIST_PUBLIC} from "../../App";

interface Issue {
    id_issue: string;
    title: string;
    header: string | null;
    year: string;
    date_publish: string;
    [key: string]: any; // For additional fields
}

export default function Main() {

        const {isLoggedIn} = useEvoContext();

        const [issueData, setIssueData] = useState<{ [key: string]: any }>({});
        const [issuePublicData, setIssuePublicData] = useState<{ [key: string]: any }>({});

    if( Object.keys(issueData).length  == 0) {
        let dp = new IssuePublicDataProvider();
        dp.getData([], {}).then((res) => {

            if (res && res.status === 'OK') {
                setIssueData(res.data)
            } else {
                // toast({
                //     title: 'Placeni se nezdařilo',
                //     description: res.errors[0] || 'Zkuste akci zopakovat.',
                //     status: 'error',
                //     duration: 5000,
                //     isClosable: true,
                // });
            }

        });
    }

    if( Object.keys(issuePublicData).length  == 0) {
        let dp = new PublicIssuesDataProvider();
        dp.getData({}, {}).then((res) => {

            if (res && res.status === 'OK') {

                const reverseDataByDate = (data: Record<string, Issue>): Array<{ key: string } & Issue> => {
                    const reversedEntries = Object.entries(data)
                        .sort(([, a], [, b]) => new Date(b.date_publish).getTime() - new Date(a.date_publish).getTime());

                    return reversedEntries.map(([key, value]) => ({ key, ...value }));
                };

                const reversedData = reverseDataByDate(res.data);
                setIssuePublicData(reversedData);
            }
        });
    }


    // if(Object.keys(issuePublicData).length > 0){
    //     console.log(Object.keys(issuePublicData).length);
    //     console.log(Object.keys(issuePublicData));
    // }


    return (
        <>
            <Header />
                <Box bgAttachment="fixed" bgSize={"cover"} bgImage="linear-gradient(rgba(255, 255, 255, 0.9),rgba(255, 255, 255, 0.9)) , url('/images/background_evo_main.png')" backgroundRepeat="no-repeat">
                    <Container maxW={'8xl'}>

                        {Object.keys(issueData).length  > 0 && (<Stack minH={'50vh'} py={20} direction={{ base: 'column', md: 'row' }}>
                                <Flex p={8} flex={1} align={'center'} justify={'center'}>
                                    <Stack spacing={6} w={'full'} maxWidth="xl">

                                        <Heading fontSize={{ base: '3xl', md: '4xl', lg: '4xl' }}>
                                            <Text py={"3"} fontSize={"sm"} /*color={'blue.400'}*/ as={'div'}>
                                                Nové vydání
                                            </Text>
                                            <Text /*color={'blue.400'}*/ as={'div'}>
                                                {issueData.title}
                                            </Text>{' '}
                                        </Heading>
                                        <Text fontSize={{ base: 'md', lg: 'lg' }} >
                                            {issueData.header}
                                        </Text>
                                        <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
                                            <ReadIssueLink privateIssue={isLoggedIn} issue_id={issueData.id_issue} />
                                        </Stack>
                                    </Stack>
                                </Flex>
                                <Flex flex={1} >
                                    <ReadIssueWithImageLink privateIssue={isLoggedIn} issue_id={issueData.id_issue}  imageSrc={issueData.image.image_url} maxWidth={{ base: "100%", md: "500px", lg: "350px" }}
                                                            rounded="md"
                                                            alt={'Login Image'}
                                                            objectFit={'cover'}/>
                                </Flex>
                            </Stack>)}
                    </Container>
                </Box>

            <Container maxW={'8xl'}>

                {Object.keys(issuePublicData).length  > 0 && (<Stack  direction={{ base: 'column', md: 'column' }}>
                    <chakra.h2 textAlign={'start'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                        Archiv vydání
                    </chakra.h2>

                    <Stack   direction={{ base: 'row', md: 'row' }}>

                        <Swiper slidesPerView={Object.keys(issuePublicData).slice(1, 5).length}
                                  spaceBetween={30}
                                  // centeredSlides={true}
                                centeredSlides={false}
                                centerInsufficientSlides={true}
                                  pagination={{
                                      clickable: true,
                                  }}
                                  navigation={true}
                                  breakpoints={{
                                      0: {
                                          slidesPerView: 1,
                                          spaceBetween: 20,
                                      },
                                      480: {
                                          slidesPerView: 1,
                                          spaceBetween: 20,
                                      },
                                      640: {
                                          slidesPerView: 2,
                                          spaceBetween: 20,
                                      },
                                      768: {
                                          slidesPerView: 3,
                                          spaceBetween: 40,
                                      },
                                      1024: {
                                          slidesPerView: Object.keys(issuePublicData).slice(1, 5).length,
                                          spaceBetween: 50,
                                      },
                                  }}
                                  modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                                  className="mySwiper"

                        >
                            { Object.entries(issuePublicData).slice(1, 5).map(([index, value]) => (
                                <SwiperSlide key={index}  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }} >
                                    <Card maxW='sm' mx={2} border="none" key={index} position={"relative"} w={["100%", "50%", "250px"]} >
                                        <ReadIssueWithImageLink privateIssue={isLoggedIn} issue_id={value.id_issue}  imageSrc={value.image.image_url} borderRadius='lg'  style={{
                                            maxWidth: "100%", // Fixed width
                                            height: "auto", // Fixed height
                                            objectFit: "cover",
                                        }} />

                                        {/*{!isLoggedIn && (<Button*/}
                                        {/*    as={"a"}*/}
                                        {/*    position="absolute"*/}
                                        {/*    bottom="20px"*/}
                                        {/*    right="20px"*/}
                                        {/*    colorScheme="pink"*/}
                                        {/*    size="sm"*/}
                                        {/*    href={"/predplatne"}*/}
                                        {/*>*/}
                                        {/*    Koupit*/}
                                        {/*</Button>)}*/}
                                    </Card>

                                    {/*<Image src={value.image} alt={`Slide ${index + 1}`} objectFit="cover" />*/}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Stack>
                    <Stack mt={10} justifyContent={"center"} direction={{ base: 'column', md: 'row' }} spacing={4}>
                        <Button colorScheme='pink' variant='outline'>
                            <a href={ROUTE_ISSUE_LIST_PUBLIC}>Zobrazit archiv vydání</a>
                        </Button>
                    </Stack>
                </Stack>)}

            </Container>
            <Footer />
        </>
    )
}


/*const BackTo = () => {
    const location = useLocation();
    const previousPage = location.state?.from;
}*/
